"use strict";
exports.__esModule = true;
exports.fetchPromotions = void 0;
var tslib_1 = require("tslib");
var auth_header_1 = require("../auth-header");
var fetchPromotions = function (props) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var requestInfo, requestInit, errorPrefix, response, body, message;
    var _a;
    return (0, tslib_1.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                requestInfo = "".concat(process.env.NEXT_PUBLIC_PUBLIC_API, "/promotions-v2");
                requestInit = {
                    method: 'POST',
                    headers: (0, tslib_1.__assign)({ 'Content-Type': 'application/json' }, (0, auth_header_1.authHeader)(props.token)),
                    body: JSON.stringify({
                        url: props.path,
                        gymId: (_a = props.gymId) !== null && _a !== void 0 ? _a : null
                    })
                };
                errorPrefix = "[".concat(exports.fetchPromotions.name, "==>PublicAPI_promotions-service] ");
                return [4, fetch(requestInfo, requestInit)["catch"](function (error) {
                        console.error("[LUMIGO_LOG] NetworkError ".concat(errorPrefix, " "), error);
                        throw error;
                    })];
            case 1:
                response = _b.sent();
                if (!(response.status !== 200)) return [3, 3];
                return [4, response.text()];
            case 2:
                body = _b.sent();
                message = "".concat(errorPrefix, " ") + "[status]: ".concat(response.status, " ") + "[statusText]: ".concat(response.statusText, " ") + "[body]: ".concat(body);
                console.log('[LUMIGO_LOG] ', message);
                throw new Error(message);
            case 3: return [4, response.json().then(function (body) { return body.data; })];
            case 4: return [2, _b.sent()];
        }
    });
}); };
exports.fetchPromotions = fetchPromotions;
